import CauseTypes from '../constants/CauseTypes';
import CaseTypes from '../constants/CaseTypes';
import RadioButtonValues from '../constants/RadioButtonValues';
import NoCompensationReasons from '../constants/NoCompensationReasons';
import noCompensationReasons from '../constants/NoCompensationReasons';
import moment from 'moment';

export function checkCaseNotCompensable(caseData)
{
    let noCompensationReason = null;
    let limitationPeriodYears = 3;

    if (caseData.cause === CauseTypes.CAUSE_GOD.value)
        noCompensationReason = NoCompensationReasons.GOD.value;

    if (caseData.type === CaseTypes.CASE_TYPE_NO_BOARDING.value)
    {
        if (caseData.was_late_for_boarding === RadioButtonValues.YES.value)
            noCompensationReason = NoCompensationReasons.TOO_LATE.value;
        else if (caseData.was_boarding_lateness_acceptable === RadioButtonValues.YES.value)
            noCompensationReason = NoCompensationReasons.SICK_OR_UNSAFE.value;
    }

    if (moment().diff(moment(caseData.flightdate), 'years') > limitationPeriodYears)
        noCompensationReason = noCompensationReasons.LIMITATION_PERIOD.value;

    return noCompensationReason;
}